<template>
<div>
<div>
  <v-app id="inspire">
    <v-content>
      <v-container  fluid>
              <div>
                <template>
                  <v-row>
                    <v-col cols="12" md="3">
  <v-expansion-panels>
    <v-expansion-panel
      v-for="(items,i) in tipoRelatorios"
      :key="i"
    >
     <v-row>
                      <v-col cols="12" md="12">
      <v-expansion-panel-header @click="relatoriosVendas(items)">{{items.descricao}}</v-expansion-panel-header>
      <v-expansion-panel-content>

          </v-expansion-panel-content>
           </v-col>

                  </v-row>
    </v-expansion-panel>

  </v-expansion-panels>
                    </v-col>

                    <!--Form -->
                     <v-col cols="12" md="9">
                       <v-container style="background-color:white;"  v-if="!callForm">
    <v-row no-gutters>
      <v-col >

<div class="text-center">

<div   :class="this.$store.state.classMessage" >{{this.$store.state.textMessage}}</div>
      <img src="../../assets/dev.png" width="100px;" ><br>
    <span   style="font-size:14px; color:black;" > FUNCIONALIDADE EM DESENVOLVIMENTO</span><br>

  </div>
      </v-col>

    </v-row>
  </v-container>

          <v-row align="center" justify="center" v-if="callForm">
          <v-col cols="12" sm="8" md="12">
              <h2>  {{this.relatorio_Dados.especificacaoRelatorio.descricao}} </h2>
              <v-card-text>
              <div>
                   <v-row >

                          <v-form ref="form" v-model="valid"  lazy-validation>
                   <v-row >
<v-col cols="12" md="6"><strong>Data de Venda</strong>
</v-col>
  <v-col cols="12" md="6">
    </v-col>
<!-- Ínicio Date Picker-->
          <v-col cols="12" md="3">
             <v-menu
         ref="menu"
    v-model="menu1"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
      >
        <template v-slot:activator="{ on }">
           <v-text-field

        v-model="date1"
        :rules="ruleTextRequired"
        label="Data ínicio"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
        </template>
            <v-date-picker
      ref="picker"
      v-model="date1"
     max="2020-12-31"
      min="1950-01-01"
    ></v-date-picker>
      </v-menu>
                       </v-col>
                        <v-col cols="12" md="3">
          <v-menu
         ref="menu"
    v-model="menu2"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
      >
        <template v-slot:activator="{ on }">
           <v-text-field

        v-model="date2"
        :rules="ruleTextRequired"
        label="Data Fim"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
        </template>
            <v-date-picker
      ref="picker"
      v-model="date2"
     max="2020-12-31"
      min="1950-01-01"
    ></v-date-picker>
      </v-menu>
       <span style="color:red" v-if="periodo > 10"> {{msg1}}</span>
      <span style="color:red" v-if="(-anoMesDia1+anoMesDia2) < 0"> {{msg2}}</span>
                       </v-col>

<!-- Fim Date Picker-->
<v-col cols="12" md="3">
         <v-autocomplete
        v-model="cliente"
        :rules="ruleTextRequired"
        item-value="cod"
        item-text="nome"
        :items="clientes"
        label="Cliente"
        :readonly="false"
        persistent-hint
        prepend-icon="person"
        return-object
      >
      </v-autocomplete>

                  </v-col>
                  <v-col cols="12" md="3">
                      <v-autocomplete
        v-model="produto"
         :rules="ruleTextRequired"
        item-value="pkProduto"
        item-text="descricao"
        :items="produtos"
        :readonly="false"
        label="Produto"
        persistent-hint
        prepend-icon="mdi-city"
        return-object
      >
      </v-autocomplete>
                  </v-col>
<v-col cols="12" md="3">
     <v-autocomplete
        v-model="vendedor"
        :rules="ruleTextRequired"
        item-value="cod"
        item-text="nome"
        :items="vendedores"
        label="Vendedor"
        :readonly="false"
        persistent-hint
        prepend-icon="person"
        return-object
      >
      </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="3">
                       <v-autocomplete
         v-model="situacao"
        :rules="ruleTextRequired"
        item-value="pkSituacao"
        item-text="descricao"
        :items="situacoes"
        label="Situação"
        :readonly="true"
        persistent-hint
        prepend-icon="mdi-city"
        return-object
      >
      </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="3">
                       <v-autocomplete
        v-model="formaPagamento"
        :rules="ruleTextRequired"
        item-value="pk_forma_pagamento"
        item-text="nome"
        :items="formaPagamentos"
        label="Forma de Pagamento"
        :readonly="false"
        persistent-hint
        prepend-icon="6_ft_apart"
        return-object
      >
      </v-autocomplete>
                  </v-col>
                  <v-card-actions>
                <v-btn   color="green" @click="verificar_datas()">Gerar</v-btn>
                <v-btn  color="blue" @click="reset()">Limpar</v-btn>
              </v-card-actions>
                   </v-row>
              </v-form>

                  </v-row>
 </div>
              </v-card-text>
          </v-col>
          </v-row>
                     </v-col>
  <!--Fim Form -->

                  </v-row>
  </template>

               </div>

      </v-container>
    </v-content>

  </v-app>

    </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    msg1: '',
    msg2: '',
    ruleTextRequired: [value => !!value || 'campo obrigatorio'],
    date1: new Date().toISOString().substr(0, 10),
    menu1: false,
    modal: false,
    date2: new Date().toISOString().substr(0, 10),
    menu2: false,
    modal2: false,
    callForm: false,
    valid: false,
    isEditing: false,
    model: null,
    isLoading: true,
    tipoRelatorios: [],
    relatorio: {
      'pkrelatorio': 0,
      'descricao': ''
    },
    relatorios: [
      [
        {
          'pkrelatorio': 1,
          'descricao': 'Relatório de Vendas'
        },
        {
          'pkrelatorio': 2,
          'descricao': 'Relatório de Orçamentos'
        },
        {
          'pkrelatorio': 3,
          'descricao': 'Produtos vendidos'
        },
        {
          'pkrelatorio': 4,
          'descricao': 'Produtos devolvidos'
        },
        {
          'pkrelatorio': 5,
          'descricao': 'Clientes que mais compram'
        },
        {
          'pkrelatorio': 6,
          'descricao': 'Comissão por produto'
        },
        {
          'pkrelatorio': 7,
          'descricao': 'Relatório de devoluções'
        },
        {
          'pkrelatorio': 8,
          'descricao': 'Comissão por venda'
        }
      ],
      [
        {
          'pkrelatorio': 1,
          'descricao': 'Compra'
        },
        {
          'pkrelatorio': 2,
          'descricao': 'Inventário'
        },
        {
          'pkrelatorio': 3,
          'descricao': 'Estoque'
        },
        {
          'pkrelatorio': 4,
          'descricao': 'Produtos comprados'
        }
      ],
      [
        {
          'pkrelatorio': 1,
          'descricao': 'Extrato'
        },
        {
          'pkrelatorio': 2,
          'descricao': 'Contas a pagar'
        },
        {
          'pkrelatorio': 3,
          'descricao': 'Contas a receber'
        }
      ],
      [
        {
          'pkrelatorio': 1,
          'descricao': 'Clientes'
        },
        {
          'pkrelatorio': 2,
          'descricao': 'Fornecedores'
        },
        {
          'pkrelatorio': 3,
          'descricao': 'Produtos'
        }
      ]
    ],
    relatorio_Dados: {
      'tipo': 0,
      'descricaoRelatorio': '',
      'especificacaoRelatorio': {
        'pkrelatorio': 0,
        'descricao': '' },
      'data_in': '',
      'data_fim': '',
      'formaPagamento': {
        'pk_forma_pagamento': 0,
        'nome': '',
        'instituicao': 0,
        'status_forma_pagamento': 0 },
      'cliente': {
        'pk_estudante': 0,
        'numero_matricula': 0,
        'saldo': 0,
        'fk_classe': 0,
        'has_multa': 0,
        'nome': '',
        'instituicao': 0,
        'data_cadastro': '',
        'status_estudante': 0,
        'ano_lectivo': 0,
        'municipio': '',
        'pai': '',
        'mae': '',
        'data_nascimento': '',
        'sexo': '',
        'curso': '',
        'numero_documento': '',
        'data_emissao': '',
        'cidade_emissao': '',
        'municipio_emissao': '',
        'rua_casa': '',
        'telefone': '',
        'email': '',
        'turma': '',
        'idmatricula_interno': '',
        'flag_isnew': 0
      },
      'produto':
      {
        'pkProduto': 0,
        'descricao': '',
        'descricaoReduzida': '',
        'codigoBarra': '',
        'armazem': 0,
        'tipoProduto': 0,
        'mercadoria': 0,
        'familia': 0,
        'precoCusto': 0.0,
        'precoComIva': 0.0,
        'precoSemIva': 0.0,
        'margem': 0.0,
        'iva': 0,
        'isencao': '',
        'descricaoPreco': '',
        'imagem': '',
        'entrada_stk': 0,
        'saida_stk': 0
      },
      'situacao': {
        'pkSituacao': 3,
        'descricao': 'Concretizada'
      },
      'vendedor': {
        'cod': 0,
        'nome': ''
      }
    },
    cliente: {
      'pk_estudante': 0,
      'numero_matricula': 0,
      'saldo': 0,
      'fk_classe': 0,
      'has_multa': 0,
      'nome': 'Todos',
      'instituicao': 0,
      'data_cadastro': '',
      'status_estudante': 0,
      'ano_lectivo': 0,
      'municipio': '',
      'pai': '',
      'mae': '',
      'data_nascimento': '',
      'sexo': '',
      'curso': '',
      'numero_documento': '',
      'data_emissao': '',
      'cidade_emissao': '',
      'municipio_emissao': '',
      'rua_casa': '',
      'telefone': '',
      'email': '',
      'turma': '',
      'idmatricula_interno': '',
      'flag_isnew': 0
    },
    clientes: [
      {
        'pk_estudante': 0,
        'numero_matricula': 0,
        'saldo': 0,
        'fk_classe': 0,
        'has_multa': 0,
        'nome': '',
        'instituicao': 0,
        'data_cadastro': '',
        'status_estudante': 0,
        'ano_lectivo': 0,
        'municipio': '',
        'pai': '',
        'mae': '',
        'data_nascimento': '',
        'sexo': '',
        'curso': '',
        'numero_documento': '',
        'data_emissao': '',
        'cidade_emissao': '',
        'municipio_emissao': '',
        'rua_casa': '',
        'telefone': '',
        'email': '',
        'turma': '',
        'idmatricula_interno': '',
        'flag_isnew': 0
      }
    ],
    vendedor: {
      'cod': 0,
      'nome': 'Todos'
    },
    vendedores: [
      {
        'cod': 0,
        'nome': 'Todos'
      },
      {
        'cod': 1,
        'nome': 'Carlos Alberto'
      }
    ],
    situacao: {
      'pkSituacao': 3,
      'descricao': 'Concretizada'
    },
    situacoes: [
      {
        'pkSituacao': 1,
        'descricao': 'Em aberto'
      },
      {
        'pkSituacao': 2,
        'descricao': 'Em andamento'
      },
      {
        'pkSituacao': 3,
        'descricao': 'Concretizada'
      },
      {
        'pkSituacao': 4,
        'descricao': 'Cancelada'
      }
    ],
    formaPagamento: {
      'pk_forma_pagamento': 0,
      'nome': 'Todos',
      'instituicao': 0,
      'status_forma_pagamento': 0
    },
    formaPagamentos: [
      {
        'pk_forma_pagamento': 0,
        'nome': '',
        'instituicao': 0,
        'status_forma_pagamento': 0
      }
    ],
    produto: {
      'pkProduto': 0,
      'descricao': 'Todos',
      'descricaoReduzida': '',
      'codigoBarra': '',
      'armazem': 0,
      'tipoProduto': 0,
      'mercadoria': 0,
      'familia': 0,
      'precoCusto': 0.0,
      'precoComIva': 0.0,
      'precoSemIva': 0.0,
      'margem': 0.0,
      'iva': 0,
      'isencao': '',
      'descricaoPreco': '',
      'imagem': '',
      'entrada_stk': 0,
      'saida_stk': 0
    },
    produtos: [
      {
        'pkProduto': 0,
        'descricao': '',
        'descricaoReduzida': '',
        'codigoBarra': '',
        'armazem': 0,
        'tipoProduto': 0,
        'mercadoria': 0,
        'familia': 0,
        'precoCusto': 0,
        'precoComIva': 0,
        'precoSemIva': 0,
        'margem': 0,
        'iva': 0,
        'isencao': ' ',
        'descricaoPreco': '',
        'imagem': '',
        'entrada_stk': 0,
        'saida_stk': 0
      }
    ],
    anoMesDia1: 0,
    anoMesDia2: 0,
    periodo: 0

  }),
  created () {
    this.isLoading = true
    this.relatorio_Dados = ls.get('relatoriosVendas')
    this.tipoRelatorios = this.relatorios[(this.relatorio_Dados.tipo) - 1]
    this.isLoading = true
    this.relatorio_Dados = ls.get('relatoriosVendas')
    this.formaPagamento_()
    this.produto_()
    this.cliente_()
    this.situacao = {
      'pkSituacao': 3,
      'descricao': 'Concretizada'
    }
  },

  methods: {
    relatoriosVendas (item) {
      this.relatorio_Dados.especificacaoRelatorio = item
      ls.set('relatoriosVendas', this.relatorio_Dados)
      if (item.pkrelatorio === 1) {
        setTimeout(() => {
          this.callForm = true
        }, 200)
      } else { this.callForm = false }
    },

    // Ínicio Formulario
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
      this.situacao = {
        'pkSituacao': 3,
        'descricao': 'Concretizada'
      }
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    async formaPagamento_ () {
      try {
        this.formaPagamentos = await axios
          .get('/formaPagamento')
          .then(res => res.data)
        this.isLoading = false
        this.formaPagamentos.unshift({
          'pk_forma_pagamento': 0,
          'nome': 'Todos',
          'instituicao': 0,
          'status_forma_pagamento': 0
        })
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async produto_ () {
      try {
        this.produtos = await axios
          .get('/produto')
          .then(res => res.data)
        this.isLoading = false
        this.produtos.unshift({
          'pkProduto': 0,
          'descricao': 'Todos',
          'descricaoReduzida': '',
          'codigoBarra': '',
          'armazem': 0,
          'tipoProduto': 0,
          'mercadoria': 0,
          'familia': 0,
          'precoCusto': 0.0,
          'precoComIva': 0.0,
          'precoSemIva': 0.0,
          'margem': 0.0,
          'iva': 0,
          'isencao': '',
          'descricaoPreco': '',
          'imagem': '',
          'entrada_stk': 0,
          'saida_stk': 0
        })
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async cliente_ () {
      try {
        this.clientes = await axios
          .get('/cliente')
          .then(res => res.data)
        this.isLoading = false
        this.clientes.unshift({
          'pk_estudante': 0,
          'numero_matricula': 0,
          'saldo': 0,
          'fk_classe': 0,
          'has_multa': 0,
          'nome': 'Todos',
          'instituicao': 0,
          'data_cadastro': '',
          'status_estudante': 0,
          'ano_lectivo': 0,
          'municipio': '',
          'pai': '',
          'mae': '',
          'data_nascimento': '',
          'sexo': '',
          'curso': '',
          'numero_documento': '',
          'data_emissao': '',
          'cidade_emissao': '',
          'municipio_emissao': '',
          'rua_casa': '',
          'telefone': '',
          'email': '',
          'turma': '',
          'idmatricula_interno': '',
          'flag_isnew': 0
        })
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    gerarRelatorio () {
      if (this.date1 && this.date2 && (-this.anoMesDia1 + this.anoMesDia2) >= 0 && this.periodo <= 10) {
        this.relatorio_Dados.data_in = this.date1
        this.relatorio_Dados.data_fim = this.date2
        this.relatorio_Dados.formaPagamento = this.formaPagamento
        this.relatorio_Dados.cliente = this.cliente
        this.relatorio_Dados.produto = this.produto
        this.relatorio_Dados.situacao = this.situacao
        this.relatorio_Dados.vendedor = this.vendedor
        setTimeout(() => {
          ls.set('relatoriosVendas', this.relatorio_Dados)
          this.$router.push('/imprimir_relatorio_venda')
        }, 1000)
      } else {
        if (!this.date1) { this.date1 = '' }
        if (!this.date2) { this.date2 = '' }
        this.msg1 = 'Período excedido, eperava-se um período entre 1 à 10 anos'
        this.msg2 = 'A data de ínicio deve ser menor que a do fim'
        setTimeout(() => {
          this.msg1 = ''
          this.msg2 = ''
        }, 900)
      }
    },
    verificar_datas () {
      let dateIni = this.date1.replace('-', '')
      let dateFim = this.date2.replace('-', '')
      this.anoMesDia2 = parseInt(dateFim.substr(0, 6) + '' + dateFim.substr(7, 9))
      this.anoMesDia1 = parseInt(dateIni.substr(0, 6) + '' + dateIni.substr(7, 9))
      this.periodo = (-parseInt(this.date1.substr(0, 4)) + parseInt(this.date2.substr(0, 4)))
      this.gerarRelatorio()
    }
    // Fim Formulario
  }
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}
.progressCircularIsMatriculaURL {
  margin: 1rem;

  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;

}
</style>
